/**
 * Description  :
 * Version      : 1.0.0
 * Author       : Luoye
 * Date         : 2022-08-03 15:25:49
 * LastEditors  : Luoye
 * FilePath     : /namibox_client_web/src/views/app-guide.ReactPage/store/actionTypes.ts
 * Copyright (C) 2022 rose. All rights reserved.
 */
export const GLOBEL_CHANGE_LOADING = 'GLOBEL/CHANGE_LOADING';
